export default {"src":"/_next/static/media/right.631cd695.svg","height":285,"width":102,"blurWidth":0,"blurHeight":0};